module.exports = __webpack_public_path__ + "static/media/illu-privacy.24b7b135.png";